/**
 * @generated SignedSource<<655f873df16294d2f8d6f122ac29210e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RowWithDragAndDrop_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RowInner_project">;
  readonly " $fragmentType": "RowWithDragAndDrop_project";
};
export type RowWithDragAndDrop_project$key = {
  readonly " $data"?: RowWithDragAndDrop_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowWithDragAndDrop_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "RowWithDragAndDrop_project",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "RowInner_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "600d8dce94ac71f00862105938b2962a";

export default node;
